import classnames from 'classnames';
import { Form, Formik } from 'formik';
import { pick } from 'lodash';
import React from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { chartActions } from '../../store/charts/chartsStore';
import { popupActions } from '../../store/popupStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import * as Yup from '../common/Yup';
import { Circles } from '../common/loadingComponent';
import Message from '../common/message';
import { MomentDate } from '../common/momentComponent';
import NoDataComponent from '../common/noDataComponent';
import Paging from '../common/pagingComponent';
import ModalInner from '../layoutItems/modalInner';
import BbInput from '../styling/bbInput';

import './relationChart.scss';

import Remove from '../../img/icons/BBiconsOdstranit';
import Edit from '../../img/icons/Upravit';

const KEYS = {
    title: 'title',
};

class LoadVisualizationPopup extends React.Component {
    state = {
        isRenaming: false,
        renameVisualizationId: undefined,
        renameTitle: undefined
    }

    componentDidMount() {
        const { selectedPage } = this.props.visualizations;
        this.props.getVisualizations(isNullOrUndefined(selectedPage) ? 1 : selectedPage);
    }

    componentDidUpdate() {
        const { loading, data, totalPages, selectedPage } = this.props.visualizations;
        if (!loading && !isNullOrUndefined(data) && data.length === 0 && selectedPage > totalPages && selectedPage > 1) {
            this.props.getVisualizations(selectedPage - 1);
        }
    }

    render() {
        return this.state.isRenaming ? this.renderRenameModal() : this.renderLoadModal()
    }

    renderLoadModal = () => (
        <ModalInner title={this.props.translate("Charts.Visualization.Load.Title")} close={this.props.close} >
            <div style={{ minHeight: "10.5em", display: "flex", flexDirection: "column" }}>
                {this.renderTable()}
            </div>
        </ModalInner>
    )

    renderTable = () => {
        const { loading, data, totalPages, selectedPage } = this.props.visualizations;

        if (loading)
            return <Circles />;

        if (isNullOrUndefined(data) || data.length === 0)
            return <NoDataComponent />;

        return (
            <>
                <table className="table table-report-section visualization-table">
                    <thead>
                        <tr>
                            <th><Translate id="Charts.Visualization.Thumbnail" /></th>
                            <th><Translate id="Charts.Visualization.Title" /></th>
                            <th><Translate id="Charts.Visualization.Type" /></th>
                            <th><Translate id="Charts.Visualization.Nodes" /></th>
                            <th><Translate id="Charts.Visualization.CreatedAt" /></th>
                            <th><Translate id="Charts.Visualization.UpdatedAt" /></th>
                            <th colSpan={3}><Translate id="Charts.Visualization.Actions" /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map(x => <tr key={x.visualizationId}>
                            <td>{x.thumbnail && <img src={x.thumbnail} title={x.title} alt={`${x.title}'s thumbnail`} />}</td>
                            <td>{x.title}</td>
                            <td>{this.props.translate(x.isStatic ? "Charts.Visualization.Static" : "Charts.Visualization.Dynamic")}</td>
                            <td>{x.nodeCount}</td>
                            <td>{isNullOrUndefined(x.insertedFormatted) ? <MomentDate value={x.inserted} /> : x.insertedFormatted}</td>
                            <td>{isNullOrUndefined(x.updatedFormatted) ? <MomentDate value={x.updated} /> : x.updatedFormatted}</td>
                            {this.renderButtons(x)}
                        </tr>)}
                    </tbody>
                </table>
                {totalPages > 1 && <div className="modal-inner-buttons" style={{ padding: "1em 0" }}>
                    <Paging
                        justify="center"
                        selectedPage={selectedPage}
                        totalPages={totalPages}
                        setPage={(page) => this.props.getVisualizations(page)} />
                </div>}
            </>
        )
    }

    renderButtons = (visualization) => {
        const buttons = [
            {
                link: (v) => <button type="button" className='link-internal' onClick={() => this.switchToRename(v.visualizationId, v.title)}>
                    {this.getIcon('rename')}
                    <Translate id="Common.Button.Rename" />
                </button>
            },
            {
                link: (v) => <button type="button" className='link-internal' onClick={() => this.props.deleteVisualization(v.visualizationId)}>
                    {this.getIcon('remove')}
                    <Translate id="Common.Button.Delete" />
                </button>
            },
            {
                link: (v) => <button type="button" className='link-internal' onClick={() => { this.redirectToVisualization(v.rootIds, v.visualizationId); this.props.close(); }}>
                    {this.getIcon('load')}
                    <Translate id="Common.Button.Load" />
                </button>
            }
        ];

        return (
            <>
                {buttons.map((button, i) =>
                    <td key={i} className='align-right'>
                        <span className="m-right-btn">
                            <div className="ml-link color">
                                <div className="ml-link-inner">
                                    {button.link(visualization)}
                                </div>
                            </div>
                        </span>
                    </td>
                )}
            </>
        )
    }

    getIcon(type) {
        switch (type) {
            case 'rename':
                return <Edit className="ml-link-icon" />
            case 'remove':
                return <Remove className="ml-link-icon" />
            case 'load':
                return <Edit className="ml-link-icon" />
            default:
                return null;
        }
    }

    redirectToVisualization(rootIds, visualizationId) {
        this.props.redirect(`/relation-chart/${rootIds.join(",")}?visualizationId=${visualizationId}`);
    }

    switchToRename(visualizationId, title) {
        this.setState({ isRenaming: true, renameVisualizationId: visualizationId, renameTitle: title });
    }

    renderRenameModal = () => {
        return (
            <ModalInner title={this.props.translate('Charts.Visualization.Rename.Title')} close={this.handleClose}>
                <Formik
                    ref={(el) => this.formRef = el}
                    enableReinitialize={true}
                    validationSchema={this.createValidationSchema()}
                    validateOnChange={false}
                    validateOnBlur={false}
                    initialValues={{
                        [KEYS.title]: this.state.renameTitle,
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        setSubmitting(false);
                        this.handleSubmit(values);
                    }}
                >
                    {({ errors }) => (
                        <Form autoComplete="off">
                            {Object.keys(errors).length > 0 && <div className="column">
                                <Message type="error" message={this.props.translate("Error.InvalidParams")} shadowed>
                                    <ul style={{ listStyleType: "disc" }}>
                                        {Object.keys(errors).map(k => <li key={k} style={{ marginLeft: "3em" }}>{this.translateErrorItem(k)}</li>)}
                                    </ul>
                                </Message>
                            </div>}
                            <BbInput name="title" type="text" label={this.props.translate('Charts.Visualization.Title')} placeholder={{ type: 'column' }} style={{ margin: 'auto' }} />
                            <div className="modal-inner-buttons" style={{ marginTop: '3em' }}>
                                <button className={classnames('bb-button gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={this.handleClose}>
                                    <Translate id='Common.Button.Cancel' />
                                </button>
                                <button type="submit" className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}><Translate id="Charts.Visualization.Rename.Button" /></button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </ModalInner>
        );
    }

    createValidationSchema = () => {
        const wrongInputMsg = this.props.translate("Search.Common.Validation.WrongInput");
        const schema = {
            'title': Yup.string().trim().required(wrongInputMsg)
        };
        return Yup.object().shape(pick(schema, ['title']));
    }

    handleSubmit = (values) => {
        this.props.renameVisualization(this.state.renameVisualizationId, values[KEYS.title], () => {
            this.props.refreshVisualizations();
            this.handleClose();
        });
    }

    handleClose = () => {
        this.setState({ isRenaming: false });
    }

    translateErrorItem = (item) =>
        (item === null || item === null || item.length < 1) ? null : this.props.translate(`Charts.Visualization.${item[0].toUpperCase()}${item.slice(1)}`)
}

export default withRouter(withLocalize(connect(
    state => state.charts,
    dispatch => bindActionCreators(({ ...chartActions, ...popupActions }), dispatch)
)(LoadVisualizationPopup)));
